import React, { useState, useEffect, useRef } from "react";
import "./reworkqueue.css";
import {
  Table,
  Input,
  Button,
  Space,
  Spin,
  Alert,
} from "antd";
import { message } from "../../components/antdMessageBridge";
import { SearchOutlined } from "@ant-design/icons";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { useNavigate } from "react-router-dom";
import EditIcon from "../../assets/img/svg/xgridediticon.svg";
import configJson from "../../Config.json";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import "../../components/commonpagination/common-pagination.css";

const Reworkqueue = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [totalRow, setTotalRow] = useState(1);
  const [searchData, setSearchData] = useState([]);
  const { accessToken, isAuthenticated } = useAuthToken();
  const navigate = useNavigate();
  // State for search functionality
  const searchInput = useRef(null);

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={confirm}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button type="primary" size="small" onClick={confirm}>
            Search
          </Button>
          <Button
            size="small"
            onClick={() => {
              handleReset(clearFilters);
              confirm(); // Explicitly call confirm to refresh the table
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select(), 100);
      }
    },
  });

  const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {

    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(newSelectedRows);
  };

  const columns = [
    {
      title: "ISBN",
      dataIndex: "isbn",
      key: "isbn",
      width: 200,
      sorter: (a, b) => a.isbn.localeCompare(b.isbn),
      ...getColumnSearchProps("isbn"),
    },
    {
      title: "BID No",
      dataIndex: "bid",
      key: "bid",
      width: 160,
      sorter: (a, b) => a.bid.localeCompare(b.bid),
      ...getColumnSearchProps("bid"),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 220,
      sorter: (a, b) => a.title.localeCompare(b.title),
      ...getColumnSearchProps("title"),
    },
    {
      title: "Author",
      dataIndex: "author",
      key: "author",
      width: 220,
      sorter: (a, b) => a.author.localeCompare(b.author),
      ...getColumnSearchProps("author"),
    },
    {
      title: "Publisher",
      dataIndex: "publisher",
      key: "publisher",
      width: 220,
      sorter: (a, b) => a.publisher.localeCompare(b.publisher),
      ...getColumnSearchProps("publisher"),
    },
    {
      title: "Book Format",
      dataIndex: "format",
      key: "format",
      width: 200,
      sorter: (a, b) => a.format.localeCompare(b.format),
      filters: [
        { text: "Hardcover", value: "Hardcover" },
        { text: "Paperback", value: "Paperback" },
        { text: "eBook", value: "eBook" },
      ],
      onFilter: (value, record) => record.format === value,
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
      width: 120,
      align: "center",
      //sorter: (a, b) => a.weight.localeCompare(b.weight),
      ...getColumnSearchProps("weight"),
    },
    {
      title: "Rack No",
      dataIndex: "rackAndShelf",
      key: "rackAndShelf",
      width: 120,
      align: "center",
      sorter: (a, b) => a.rackAndShelf.localeCompare(b.rackAndShelf),
      ...getColumnSearchProps("rackAndShelf"),
    },
    {
      title: "Shelf ID",
      width: 120,
      //dataIndex: 'shelfID',
      //key: 'shelfID',
      //sorter: (a, b) => a.shelfID.localeCompare(b.shelfID),
      //...getColumnSearchProps('shelfID'),
      key: "shelfID", // Keep the key for internal tracking
      render: () => " ",
    },

    {
      title: "Status",
      dataIndex: "statusText",
      key: "statusText",
      width: 200,
      sorter: (a, b) => a.statusText.localeCompare(b.statusText),
      filters: [
        { text: "Manifest Creation -TBI", value: "Manifest Creation -TBI" },
        { text: "Manifest Creation - WIP", value: "Manifest Creation - WIP" },
        {
          text: "Manifest Verification - TBI",
          value: "Manifest Verification - TBI",
        },
        {
          text: "Manifest Verification - WIP",
          value: "Manifest Verification - WIP",
        },
        { text: "Manifest Accepted", value: "Manifest Accepted" },
        { text: "Manifest Reject", value: "Manifest Reject" },
      ],
      onFilter: (value, record) => record.statusText === value,
      //title: 'Status',
      //key: 'status', // Keep the key for internal tracking
      render: (_, record) => (
        <Space size="middle" className="grid-badge">
          <span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_875_15026)">
                <path
                  d="M10.2621 2.70235L9.86074 3.14833V3.14833L10.2621 2.70235ZM12.9013 5.07761L12.4999 5.52359L12.9013 5.07761ZM14.4362 6.76932L13.8881 7.01342V7.01342L14.4362 6.76932ZM2.11454 13.8855L2.53881 13.4613H2.53881L2.11454 13.8855ZM13.8858 13.8855L13.4615 13.4613L13.8858 13.8855ZM9.3335 14.6666V14.0666H6.66683V14.6666V15.2666H9.3335V14.6666ZM1.3335 9.33325H1.9335V6.66658H1.3335H0.733496V9.33325H1.3335ZM14.6668 9.04185H14.0668V9.33325H14.6668H15.2668V9.04185H14.6668ZM10.2621 2.70235L9.86074 3.14833L12.4999 5.52359L12.9013 5.07761L13.3027 4.63164L10.6635 2.25637L10.2621 2.70235ZM14.6668 9.04185H15.2668C15.2668 7.92511 15.2789 7.18687 14.9843 6.52521L14.4362 6.76932L13.8881 7.01342C14.0547 7.38762 14.0668 7.81912 14.0668 9.04185H14.6668ZM12.9013 5.07761L12.4999 5.52359C13.4088 6.34156 13.7214 6.63922 13.8881 7.01342L14.4362 6.76932L14.9843 6.52521C14.6896 5.86355 14.1328 5.3787 13.3027 4.63164L12.9013 5.07761ZM6.68669 1.33325V1.93325C7.74879 1.93325 8.12466 1.94252 8.45802 2.07044L8.67298 1.51026L8.88794 0.950092C8.29872 0.723989 7.65792 0.733252 6.68669 0.733252V1.33325ZM10.2621 2.70235L10.6635 2.25637C9.94509 1.6098 9.47707 1.17616 8.88794 0.950092L8.67298 1.51026L8.45802 2.07044C8.79146 2.19839 9.07535 2.44147 9.86074 3.14833L10.2621 2.70235ZM6.66683 14.6666V14.0666C5.39279 14.0666 4.49762 14.0653 3.82072 13.9743C3.16108 13.8856 2.79927 13.7217 2.53881 13.4613L2.11454 13.8855L1.69028 14.3098C2.21087 14.8304 2.86812 15.057 3.66082 15.1636C4.43627 15.2679 5.42671 15.2666 6.66683 15.2666V14.6666ZM1.3335 9.33325H0.733496C0.733496 10.5734 0.732222 11.5638 0.836477 12.3393C0.943054 13.132 1.16969 13.7892 1.69028 14.3098L2.11454 13.8855L2.53881 13.4613C2.27835 13.2008 2.11446 12.839 2.02578 12.1794C1.93477 11.5025 1.9335 10.6073 1.9335 9.33325H1.3335ZM9.3335 14.6666V15.2666C10.5736 15.2666 11.5641 15.2679 12.3395 15.1636C13.1322 15.057 13.7895 14.8304 14.31 14.3098L13.8858 13.8855L13.4615 13.4613C13.2011 13.7217 12.8392 13.8856 12.1796 13.9743C11.5027 14.0653 10.6075 14.0666 9.3335 14.0666V14.6666ZM14.6668 9.33325H14.0668C14.0668 10.6073 14.0656 11.5025 13.9745 12.1794C13.8859 12.839 13.722 13.2008 13.4615 13.4613L13.8858 13.8855L14.31 14.3098C14.8306 13.7892 15.0573 13.132 15.1638 12.3393C15.2681 11.5638 15.2668 10.5734 15.2668 9.33325H14.6668ZM1.3335 6.66658H1.9335C1.9335 5.39254 1.93477 4.49737 2.02578 3.82048C2.11446 3.16084 2.27835 2.79903 2.53881 2.53856L2.11454 2.1143L1.69028 1.69004C1.16969 2.21062 0.943054 2.86787 0.836477 3.66058C0.732222 4.43602 0.733496 5.42647 0.733496 6.66658H1.3335ZM6.68669 1.33325V0.733252C5.4399 0.733252 4.44468 0.731988 3.66614 0.836186C2.8708 0.942632 2.21133 1.16898 1.69028 1.69004L2.11454 2.1143L2.53881 2.53856C2.7988 2.27857 3.16171 2.1144 3.82533 2.02558C4.50575 1.93452 5.40609 1.93325 6.68669 1.93325V1.33325Z"
                  fill="#000579"
                />
                <path
                  opacity="0.5"
                  d="M8.6665 1.66675V3.33341C8.6665 4.90476 8.6665 5.69044 9.15466 6.17859C9.64281 6.66675 10.4285 6.66675 11.9998 6.66675H14.6665"
                  stroke="#000579"
                  strokeWidth="1.2"
                />
                <path
                  opacity="0.5"
                  d="M4.00016 10.6667L7.3335 10.6667M7.3335 10.6667L6.0835 9.33333M7.3335 10.6667L6.0835 12"
                  stroke="#000579"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_875_15026">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span>{record.statusText}</span>
        </Space>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          {record.status != 12 && record.status != 8 && record.status != 10 && (
            <Button
              type="text"
              icon={<img src={EditIcon} />}
              onClick={() => handleEdit(record.bid)}
            />
          )}
          {/*<Popconfirm*/}
          {/*    title="Are you sure to delete this item?"*/}
          {/*    onConfirm={() => handleDelete(record.referenceId)}*/}
          {/*    okText="Yes"*/}
          {/*    cancelText="No"*/}
          {/*>*/}
          {/*    <Button type="danger" icon={<DeleteOutlined />} />*/}
          {/*</Popconfirm>*/}
        </Space>
      ),
    },
  ];
  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "odd-row" : "even-row";
  };

  const handleTableChange = (pagination, filters, sorter) => {

    {
      searchData == ""
        ? fetchData(pagination.current, pagination.pageSize)
        : handleSearch(
          pagination.current,
          pagination.pageSize,
          searchedColumn,
          searchText
        );
    }
  };
  const handleEdit = (key) => {

    navigate("/Eintake", { state: { key } });
  };

  const handleSearch = async (page, pageSize, dataIndex, selectedKeys) => {
    setSearchedColumn(dataIndex);
    setSearchText(selectedKeys);

    setLoading(true);

    const payload = {
      pageNo: page,
      pageSize: pageSize,
      search: "{}",
      orderByColumn: "string",
      orderBy: true,
    };



    try {
      const myHeaders = {
        "Content-Type": "application/json",
      };
      const response = await fetch(CommonObj.Endpoints.GetBookDetails, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      const books = Array.isArray(result) ? result : [result];
      const formattedData = books.map((item) => ({
        ...item,
        key: item.referenceId,
      }));
      setData(formattedData);
      setTotalRow(formattedData[0].totalRows);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (key) => {
    message.success(`Deleted item with key: ${key}`);
    const newData = data.filter((item) => item.key !== key);
    setData(newData);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const clearSelection = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };
  const fetchData = async (_unusedParam, _unusedParam2) => {
    const payload = {
      pageNo: 1,
      pageSize: 10,
      search: "{}",
      orderByColumn: "string",
      orderBy: true,
    };

    setLoading(true);
    try {
      const myHeaders = {
        // Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        "X-CSRF-Token": encryptTimestamp()
      };

      const response = await fetch(CommonObj.Endpoints.QCGetReworkBookDetails, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      const books = Array.isArray(result) ? result : [result];
      const formattedData = books.map((item) => ({
        ...item,
        key: item.referenceId,
      }));
      setData(formattedData);
      setTotalRow(formattedData[0].totalRows);

    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData(1, 100);
  }, []);

  if (loading) {
    return (
      <Spin size="large" style={{ margin: "20px auto" }} />
    );
  }

  if (error) {
    return (
      <Alert
        message="Error"
        description="Failed to fetch data from the API."
        type="error"
        showIcon
      />
    );
  }

  return (
    <div className="active-page-container">
      <div className="active-page-header-container">
        <div className="active-page-header-title-container">
          <h4>Rework Queue</h4>
        </div>
        <div className="active-page-header-action-container">
          <div className="active-page-header-button-container">
            <button className="active-page-header-button">
              <span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_875_15157)">
                    <path
                      d="M11.5447 3.04024L11.1433 3.48621L11.1433 3.48621L11.5447 3.04024ZM14.5138 5.71241L14.1124 6.15839L14.5138 5.71241ZM16.2405 7.61557L15.6924 7.85967L15.6924 7.85968L16.2405 7.61557ZM2.37868 15.6213L2.80294 15.1971H2.80294L2.37868 15.6213ZM15.6213 15.6213L15.1971 15.1971L15.6213 15.6213ZM10.5 16.5V15.9H7.5V16.5V17.1H10.5V16.5ZM1.5 10.5H2.1V7.5H1.5H0.9V10.5H1.5ZM16.5 10.1722H15.9V10.5H16.5H17.1V10.1722H16.5ZM11.5447 3.04024L11.1433 3.48621L14.1124 6.15839L14.5138 5.71241L14.9152 5.26643L11.9461 2.59426L11.5447 3.04024ZM16.5 10.1722H17.1C17.1 8.90922 17.1121 8.09787 16.7886 7.37147L16.2405 7.61557L15.6924 7.85968C15.8879 8.29862 15.9 8.80322 15.9 10.1722H16.5ZM14.5138 5.71241L14.1124 6.15839C15.1299 7.07417 15.4969 7.42073 15.6924 7.85967L16.2405 7.61557L16.7886 7.37147C16.4651 6.64507 15.8539 6.11131 14.9152 5.26643L14.5138 5.71241ZM7.52234 1.5V2.1C8.71153 2.1 9.15094 2.10926 9.54196 2.25931L9.75692 1.69914L9.97188 1.13897C9.325 0.890737 8.62066 0.9 7.52234 0.9V1.5ZM11.5447 3.04024L11.9461 2.59426C11.1337 1.8631 10.6187 1.38716 9.97188 1.13897L9.75692 1.69914L9.54196 2.25931C9.93306 2.40939 10.2639 2.69476 11.1433 3.48621L11.5447 3.04024ZM7.5 16.5V15.9C6.06882 15.9 5.0558 15.8987 4.28813 15.7955C3.53772 15.6946 3.11222 15.5063 2.80294 15.1971L2.37868 15.6213L1.95442 16.0456C2.52382 16.615 3.24476 16.866 4.12824 16.9848C4.99445 17.1013 6.10275 17.1 7.5 17.1V16.5ZM1.5 10.5H0.9C0.9 11.8973 0.898726 13.0055 1.01519 13.8718C1.13397 14.7552 1.38501 15.4762 1.95442 16.0456L2.37868 15.6213L2.80294 15.1971C2.49367 14.8878 2.30537 14.4623 2.20448 13.7119C2.10127 12.9442 2.1 11.9312 2.1 10.5H1.5ZM10.5 16.5V17.1C11.8973 17.1 13.0055 17.1013 13.8718 16.9848C14.7552 16.866 15.4762 16.615 16.0456 16.0456L15.6213 15.6213L15.1971 15.1971C14.8878 15.5063 14.4623 15.6946 13.7119 15.7955C12.9442 15.8987 11.9312 15.9 10.5 15.9V16.5ZM16.5 10.5H15.9C15.9 11.9312 15.8987 12.9442 15.7955 13.7119C15.6946 14.4623 15.5063 14.8878 15.1971 15.1971L15.6213 15.6213L16.0456 16.0456C16.615 15.4762 16.866 14.7552 16.9848 13.8718C17.1013 13.0055 17.1 11.8973 17.1 10.5H16.5ZM1.5 7.5H2.1C2.1 6.06882 2.10127 5.0558 2.20448 4.28813C2.30537 3.53772 2.49367 3.11222 2.80294 2.80294L2.37868 2.37868L1.95442 1.95442C1.38501 2.52382 1.13397 3.24476 1.01519 4.12824C0.898726 4.99445 0.9 6.10275 0.9 7.5H1.5ZM7.52234 1.5V0.9C6.11759 0.9 5.0039 0.898736 4.13418 1.01514C3.24765 1.13379 2.52428 1.38455 1.95442 1.95442L2.37868 2.37868L2.80294 2.80294C3.11175 2.49413 3.53856 2.30555 4.29336 2.20453C5.06497 2.10126 6.08378 2.1 7.52234 2.1V1.5Z"
                      fill="currentColor"
                    />
                    <path
                      opacity="0.5"
                      d="M9.75 1.875V3.75C9.75 5.51777 9.75 6.40165 10.2992 6.95083C10.8483 7.5 11.7322 7.5 13.5 7.5H16.5"
                      stroke="currentColor"
                      strokeWidth="1.2"
                    />
                    <path
                      opacity="0.5"
                      d="M6.375 10.125L6.375 13.875M6.375 13.875L7.875 12.4688M6.375 13.875L4.875 12.4688"
                      stroke="currentColor"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_875_15157">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>{" "}
              </span>
            </button>
          </div>
          <div className="active-page-header-button-container">
            <button className="active-page-header-add-button">
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1193_9975)">
                    <circle
                      opacity="0.5"
                      cx="8.00016"
                      cy="7.99992"
                      r="6.66667"
                      stroke="currentColor"
                      strokeWidth="1.2"
                    />
                    <path
                      d="M10 8.00002L8 8.00002M8 8.00002L6 8.00002M8 8.00002L8 6M8 8.00002L8 10"
                      stroke="currentColor"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1193_9975">
                      <rect width="16" height="16" fill="currentColor" />
                    </clipPath>
                  </defs>
                </svg></span>Add New</button>
          </div>
        </div>
      </div>
      <div className="active-page-body-container">
        <div className="rounded-table-wrapper">
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={data}
            className="common-pagination common-grid"
            pagination={{
              //showTotal={(totalRow, range) => `${range[0]}-${range[1]} of ${totalRow} items`},
                pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
              showSizeChanger: true,
              position: ["bottomRight"],
              total: totalRow,
              defaultPageSize: 10,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} results`,
            }}
            rowKey={(record) => record.bid + record.isbn}
            /*     rowKey={(record) => record.bid}*/
            onChange={handleTableChange}
            scroll={{ x: "max-content", y: "calc(100vh - 280px)" }}
            rowClassName={getRowClassName}
          />
        </div>
      </div>
      <div className="active-page-footer-container">
        <div className="active-page-action-container">
          <div></div>
          <div className="active-page-buttons-container">
            <button className="active-page-download-button">
              <span>
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.49984 14.9856C4.2053 14.9466 3.43316 14.8022 2.89874 14.2678C2.1665 13.5355 2.1665 12.357 2.1665 10C2.1665 7.64298 2.1665 6.46447 2.89874 5.73223C3.63097 5 4.80948 5 7.1665 5H13.8332C16.1902 5 17.3687 5 18.1009 5.73223C18.8332 6.46447 18.8332 7.64298 18.8332 10C18.8332 12.357 18.8332 13.5355 18.1009 14.2678C17.5665 14.8022 16.7944 14.9466 15.4998 14.9856"
                    stroke="url(#paint0_linear_1306_12533)"
                    strokeWidth="1.5"
                  />
                  <path
                    opacity="0.5"
                    d="M8 8.3335H5.5"
                    stroke="url(#paint1_linear_1306_12533)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M16.3335 11.6665L4.66683 11.6665"
                    stroke="url(#paint2_linear_1306_12533)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M15.5 11.6665V13.3332C15.5 15.6902 15.5 16.8687 14.7678 17.6009C14.0355 18.3332 12.857 18.3332 10.5 18.3332C8.14298 18.3332 6.96447 18.3332 6.23223 17.6009C5.5 16.8687 5.5 15.6902 5.5 13.3332V11.6665"
                    stroke="url(#paint3_linear_1306_12533)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    opacity="0.5"
                    d="M15.4858 5.00008C15.4468 3.70554 15.3024 2.9334 14.768 2.39898C14.0357 1.66675 12.8572 1.66675 10.5002 1.66675C8.14319 1.66675 6.96468 1.66675 6.23244 2.39898C5.69803 2.9334 5.55365 3.70554 5.51465 5.00008"
                    stroke="url(#paint4_linear_1306_12533)"
                    strokeWidth="1.5"
                  />
                  <circle
                    opacity="0.5"
                    cx="14.6668"
                    cy="8.33333"
                    r="0.833333"
                    fill="url(#paint5_linear_1306_12533)"
                  />
                  <path
                    opacity="0.5"
                    d="M13 13.75H8"
                    stroke="url(#paint6_linear_1306_12533)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    opacity="0.5"
                    d="M11.3335 15.8335H8.00016"
                    stroke="url(#paint7_linear_1306_12533)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1306_12533"
                      x1="19.3332"
                      y1="9.9652"
                      x2="2.43072"
                      y2="12.8959"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#033D9B" />
                      <stop offset="1" stopColor="#29ACD5" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_1306_12533"
                      x1="5.425"
                      y1="7.83626"
                      x2="7.87158"
                      y2="7.20087"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#033D9B" />
                      <stop offset="1" stopColor="#29ACD5" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_1306_12533"
                      x1="4.31683"
                      y1="11.1693"
                      x2="9.25335"
                      y2="5.18644"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#033D9B" />
                      <stop offset="1" stopColor="#29ACD5" />
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_1306_12533"
                      x1="15.8"
                      y1="14.9814"
                      x2="5.60128"
                      y2="16.5706"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#033D9B" />
                      <stop offset="1" stopColor="#29ACD5" />
                    </linearGradient>
                    <linearGradient
                      id="paint4_linear_1306_12533"
                      x1="15.7849"
                      y1="3.32421"
                      x2="6.28596"
                      y2="6.27596"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#033D9B" />
                      <stop offset="1" stopColor="#29ACD5" />
                    </linearGradient>
                    <linearGradient
                      id="paint5_linear_1306_12533"
                      x1="15.5502"
                      y1="8.32873"
                      x2="13.8277"
                      y2="8.50766"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#033D9B" />
                      <stop offset="1" stopColor="#29ACD5" />
                    </linearGradient>
                    <linearGradient
                      id="paint6_linear_1306_12533"
                      x1="7.85"
                      y1="13.2528"
                      x2="11.9634"
                      y2="11.1162"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#033D9B" />
                      <stop offset="1" stopColor="#29ACD5" />
                    </linearGradient>
                    <linearGradient
                      id="paint7_linear_1306_12533"
                      x1="7.90016"
                      y1="15.3363"
                      x2="11.0095"
                      y2="14.2596"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#033D9B" />
                      <stop offset="1" stopColor="#29ACD5" />
                    </linearGradient>
                  </defs>
                </svg>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_319_32002)">
                    <path
                      d="M4.99999 14.9856C3.70545 14.9466 2.93331 14.8022 2.39889 14.2678C1.66666 13.5355 1.66666 12.357 1.66666 10C1.66666 7.64298 1.66666 6.46447 2.39889 5.73223C3.13112 5 4.30963 5 6.66666 5H13.3333C15.6903 5 16.8689 5 17.6011 5.73223C18.3333 6.46447 18.3333 7.64298 18.3333 10C18.3333 12.357 18.3333 13.5355 17.6011 14.2678C17.0667 14.8022 16.2945 14.9466 15 14.9856"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      opacity="0.5"
                      d="M7.5 8.33331H5"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M15.8333 11.6667L4.16668 11.6667"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M15 11.6667V13.3334C15 15.6904 15 16.8689 14.2678 17.6011C13.5355 18.3334 12.357 18.3334 10 18.3334C7.64298 18.3334 6.46447 18.3334 5.73223 17.6011C5 16.8689 5 15.6904 5 13.3334V11.6667"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      opacity="0.5"
                      d="M14.9856 5.00002C14.9466 3.70548 14.8022 2.93334 14.2678 2.39892C13.5355 1.66669 12.357 1.66669 10 1.66669C7.64298 1.66669 6.46446 1.66669 5.73223 2.39892C5.19781 2.93334 5.05344 3.70548 5.01443 5.00002"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <circle
                      opacity="0.5"
                      cx="14.1667"
                      cy="8.33333"
                      r="0.833333"
                      fill="white"
                    />
                    <path
                      opacity="0.5"
                      d="M12.5 13.75H7.5"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      opacity="0.5"
                      d="M10.8333 15.8333H7.50001"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_319_32002">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg></span>Download</button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Reworkqueue;
